<!-- Pressreleases -->
//jQuery(document).ready(function ($) {
    // $("#press").ready(function () {
    //     if ($('#press').length) {
    //         var lang = $("html").attr("lang");
    //         var language = "en";
    //         var url = "/investors/press-releases/post/"
    //         if (lang == "sv-SE") {
    //             url = "/sv/investerare/pressmeddelanden/post/";
    //             language = 'sv';
    //         } else if (lang == "de-DE") {
    //             url = "/de/investors/pressemitteilungen/post/";
    //             language = 'en';
    //         }
    //
    //         $("#press").press({
    //             dataUrl: 'https://vp254.alertir.com/afw/data/',
    //             issuer: 'studsvik',
    //             language: ['' + language + ''],
    //             type:'',
    //             limit: 1,
    //             template: function (data) {
    //                 const published = moment.tz(data.published, "Europe/Stockholm").format('DD MMMM, YYYY');
    //                 return '<a href="' + url + '?press-id=' + data.id + '"><h4 class="mb-4">' + data.headline + '</h4><p>' + published + '</p>' + data.summary + '</a><br />'
    //             }
    //         })
    //     }
    // });
    // Pressrelease post
//     if ($('#pressrelease').length) {
//         var searchPressID = new URLSearchParams(window.location.search)
//         var pressID = searchPressID.get('press-id')
//         if (pressID) {
//             var urlRequest = 'https://vp254.alertir.com/afw/data/?type=press&issuer=studsvik&id=' + pressID;
//             $.ajax({
//                 url: urlRequest,
//                 dataType: 'text',
//                 success: function (data) {
//                     const jsonObject = JSON.parse(data);
//                     const series = jsonObject?.data?.studsvik?.series?.[0];
//
//                     if (series) {
//                         const item = $('<div>').addClass('press-item');
//                         const itemContent = $('<div>').addClass('press-item-content');
//                         const headline = series.headline;
//                         const published = moment.tz(series.published, "Europe/Stockholm").format('YYYY-MM-DD HH:mm');
//                         const formattedDate = new Date(published).toISOString().slice(0, 16).replace("T", " ");
//                         const body = decodeHTML(series.body);
//
//                         const files = series.files;
//                         if (files && files.length > 0) {
//                             const div_downloads = $('<div>').addClass('press-item-downloads');
//                             $('<h4>').html('Downloads').appendTo(div_downloads);
//                             $('<span class="w-full inline-block border-b border-dark-grey mt-6 mb-10"></span>').appendTo(div_downloads);
//
//                             $.each(files, function(index, file) {
//                                 $('<a>').attr('href', file.location)
//                                     .attr('target', '_blank')
//                                     .text(file.attributes.title)
//                                     .appendTo(div_downloads);
//
//                                 if (index < files.length - 1) {
//                                     $('<br>').appendTo(div_downloads);
//                                 }
//                             });
//
//                             div_downloads.appendTo(item);
//                         }
//
//                         $('<h2 class="mb-6">').html(headline + '<i class="icon-corner"></i>').appendTo(itemContent);
//                         $('<div>').addClass('press-item-date').text(formattedDate).appendTo(itemContent);
//                         $(body).appendTo(itemContent);
//
//                         itemContent.appendTo(item);
//
//                         $('#pressrelease').html(item);
//                     } else {
//                         $('#pressrelease').html("");
//                     }
//                 },
//                 error: function (xhr, status) {
//                     console.log(status)
//                 }
//             })
//         }
//
//     }
//});

// Ticker
jQuery(document).ready(function ($) {
    //$("#ticker").ready(function () {
    if ($('#ticker').length) {
        var lang = $("html").attr("lang");

        $("#ticker").ticker({
            dataUrl: 'https://vp254.alertir.com/afw/data/',
            language: 'sv',
            instrument: [{
                id: 'MDA:5547',
                name: 'SVIK'
            }],
            decimalPoints: 1,
            autoUpdate: 60,

            template: function (data) {

                function getDateDescription(d1, d2) {
                    if (d1.toDateString() === d2.toDateString()) {
                        if (lang === "sv-SE") {
                            return 'Idag';
                        } else {
                            return 'Today';
                        }
                    }

                    d1.setDate(d1.getDate() - 1);
                    if (d1.toDateString() === d2.toDateString()) {
                        return d2;
                    }

                    return moment.tz(d2, "Europe/Stockholm").format('YYYY-MM-DD');
                }

                function getTimeString(d) {
                    return moment.tz(d, "Europe/Stockholm").format('HH:mm');
                }

                function isNoDataTime(d) {
                    const dayOfWeek = d.getDay();
                    const time = getTimeString(d);

                    if (dayOfWeek === 0 || dayOfWeek === 6 || (dayOfWeek >= 1 && dayOfWeek <= 5 && time >= '00:00' && time < '09:00')) {
                        return true;
                    }

                    return false;
                }

                function getFormattedDateTime(data) {
                    const now = new Date();
                    const dataDate = new Date(data.value.date * 1000);

                    if (data.isFallback || isNoDataTime(now)) {
                        if (lang === "sv-SE") {
                            return 'Senaste';
                        } else {
                            return 'Latest';
                        }
                    } else {
                        return getDateDescription(now, dataDate) + ' ' + getTimeString(dataDate);
                    }
                }

                const isPositiveDiff = data.formatted.diff > 0;
                const pos = isPositiveDiff ? '+' : '';
                const last = data.formatted.last;
                const diff = data.formatted.diff;
                const diffpercent = data.value.diffpercent ? ` (${data.formatted.diffpercent}%)` : '';
                const formattedDateTime = getFormattedDateTime(data);

                let title = "The Studsvik Share";
                if (lang === "sv-SE") {
                    title = "Studsvikaktien";
                }

                return `<strong>${title}</strong> | ${formattedDateTime}<p>` +
                    `<div><div class="stock-tick__img"></div><span>${data.formatted.last}</span> SEK ` +
                    `${pos}${diff} SEK ${diffpercent}</p></div>`;

            }
        });
    }
});

function decodeHTML(text) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
}

<!-- end Simple Custom CSS and JS -->

//# sourceMappingURL=ticker.js.map
